import { useEffect, useState } from 'react';
import { Button, ButtonGroup } from 'react-bootstrap';
import { IoAddOutline } from 'react-icons/io5';
import { useHistory, useLocation } from 'react-router-dom';
import {
  ActionButton,
  Alert,
  BackButton,
  CRUDLayout,
  DataStatus,
  FilterButton,
  InputSearch,
  Pagination,
  TBody,
  Td,
  TdFixed,
  Th,
  THead,
  ThFixed,
  Tr,
} from 'components';
import { PostingRealisasiWorkOrderApi } from 'api';
import { DateConvert, PageNumber } from 'utilities';
import { ModalFilterPreform } from './components';
import { withDropdownProvider } from './context';

export const ListPreformPostingWorkOrder = withDropdownProvider(
  ({ setNavbarTitle }) => {
    const history = useHistory();
    const location = useLocation();
    const title = 'Posting Realisasi Work Order';
    const filter = location.state?.filter ?? {};

    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState([]);
    const [totalPage, setTotalPage] = useState(1);
    const [totalData, setTotalData] = useState('');
    const [modalFilter, setModalFilter] = useState(false);
    const [dataFilter, setDataFilter] = useState({
      active: filter.post?.active,
      page: filter.post?.page ?? 1,
      per_page: filter.post?.per_page ?? 10,
      q: filter.post?.q ?? '',

      tgl_maintenance_request_master_start:
        filter.post?.tgl_maintenance_request_master_start,
      tgl_maintenance_request_master_end:
        filter.post?.tgl_maintenance_request_master_end,

      tgl_work_order_start: filter.post?.tgl_work_order_start,
      tgl_work_order_end: filter.post?.tgl_work_order_end,

      tgl_realisasi_work_order_start:
        filter.post?.tgl_realisasi_work_order_start,
      tgl_realisasi_work_order_end: filter.post?.tgl_realisasi_work_order_end,

      id_item_aset: filter.post?.id_item_aset,
    });
    const [alertConfig, setAlertConfig] = useState({
      show: false,
      variant: 'primary',
      text: '',
    });
    const [collapsedIndex, setCollapsedIndex] = useState(-1);

    const getData = () => {
      setIsLoading(true);

      const filterData = { ...dataFilter };
      delete filterData.active;

      PostingRealisasiWorkOrderApi.getRealisasi(filterData)
        .then((res) => {
          setData(res.data.data);
          setTotalPage(res.data.total_page);
          setTotalData(res.data.data_count);
        })
        .catch(() => {
          setAlertConfig({
            show: true,
            variant: 'danger',
            text: 'Data gagal dimuat!',
          });
        })
        .finally(() => setIsLoading(false));
    };

    const onInputSearchChange = (e) => {
      const key = e.target.value;

      setDataFilter({
        ...dataFilter,
        page: 1,
        q: key,
      });
      setAlertConfig({
        show: key ? true : false,
        variant: 'primary',
        text: 'Hasil dari pencarian: ' + key,
      });
    };

    useEffect(() => {
      setNavbarTitle(title);
      // eslint-disable-next-line
    }, []);

    useEffect(() => {
      setCollapsedIndex(-1);
      getData();
      // eslint-disable-next-line
    }, [dataFilter]);

    const toggleModalFilter = () => setModalFilter(!modalFilter);

    const Table = () => (
      <>
        <b>List Data Realisasi Work Order Yang Siap Direalisasi </b>
        <CRUDLayout.Table>
          <THead>
            <Tr>
              <ThFixed>No</ThFixed>
              <ThFixed>Informasi Realisasi Work Order</ThFixed>
              <ThFixed>Informasi Work Order</ThFixed>
              <ThFixed>Informasi Maintenance Request</ThFixed>
              <Th>Item Aset</Th>
              <Th>Rincian Pekerjaan</Th>
              <ThFixed>Aksi</ThFixed>
            </Tr>
          </THead>
          <TBody>
            {data?.map((val, index) => (
              <Tr key={index}>
                <TdFixed>
                  {PageNumber(dataFilter.page, dataFilter.per_page, index)}
                </TdFixed>

                <Td>
                  <div>
                    {val.tgl_realisasi_work_order
                      ? DateConvert(new Date(val.tgl_realisasi_work_order))
                          .defaultDMY
                      : '-'}
                  </div>
                  <div>{val.no_realisasi_work_order ?? '-'}</div>
                </Td>

                <Td>
                  <div>
                    {val.tgl_work_order
                      ? DateConvert(new Date(val.tgl_work_order)).defaultDMY
                      : '-'}
                  </div>
                  <div>{val.no_work_order ?? '-'}</div>
                </Td>

                <Td>
                  <div>
                    {val.tgl_maintenance_request_master
                      ? DateConvert(
                          new Date(val.tgl_maintenance_request_master),
                        ).defaultDMY
                      : '-'}
                  </div>
                  <div>{val.no_maintenance_request_master ?? '-'}</div>
                </Td>

                <Td>{val.nama_item_aset ?? '-'}</Td>

                <Td>
                  {val.rincian_pekerjaan?.length === 0 ? (
                    '-'
                  ) : (
                    <>
                      <ul className="pl-3 m-0">
                        {val?.rincian_pekerjaan
                          ?.filter((_val, indexPermintaan) => {
                            if (index === collapsedIndex) {
                              return (
                                indexPermintaan <=
                                val?.rincian_pekerjaan?.length
                              );
                            } else {
                              return indexPermintaan <= 2;
                            }
                          })
                          .map((val, index) => (
                            <li key={index}>{`${
                              val.nama_pekerjaan ?? '-'
                            } ${parseFloat(
                              val.persentase_progress ?? 0,
                            )}%`}</li>
                          ))}
                      </ul>
                      {val?.rincian_pekerjaan?.length > 3 &&
                        index !== collapsedIndex && (
                          <Button
                            variant="link"
                            className="pt-0"
                            onClick={() => setCollapsedIndex(index)}
                          >
                            Selengkapnya...
                          </Button>
                        )}
                    </>
                  )}
                </Td>
                <TdFixed>
                  <ButtonGroup>
                    <ActionButton
                      text={<IoAddOutline size={12} />}
                      className="my-1"
                      size="sm"
                      onClick={() => {
                        console.log(val.id_realisasi_work_order);
                        history.push(
                          `/transaksi/posting-realisasi-work-order/tambah/${val.id_realisasi_work_order}`,
                          {
                            filter: {
                              ...filter,
                              post: dataFilter,
                            },
                          },
                        );
                      }}
                    />
                  </ButtonGroup>
                </TdFixed>
              </Tr>
            ))}
          </TBody>
        </CRUDLayout.Table>
        <Pagination
          dataLength={dataFilter.per_page}
          dataPage={
            totalData <= 10
              ? data?.length
              : data?.map((_res, index) => {
                  if (index === data.length - 1) {
                    return PageNumber(
                      dataFilter.page,
                      dataFilter.per_page,
                      index,
                    );
                  } else {
                    return null;
                  }
                })
          }
          dataNumber={data?.map((_res, index) => {
            if (index === 0) {
              return PageNumber(dataFilter.page, dataFilter.per_page, index);
            } else {
              return null;
            }
          })}
          dataCount={totalData}
          onDataLengthChange={(e) => {
            setDataFilter({
              ...dataFilter,
              per_page: e.target.value,
              page: 1,
            });
          }}
          currentPage={dataFilter.page}
          totalPage={totalPage}
          onPaginationChange={({ selected }) =>
            setDataFilter({
              ...dataFilter,
              page: selected + 1,
            })
          }
        />
      </>
    );

    return (
      <CRUDLayout>
        <CRUDLayout.Head>
          <CRUDLayout.HeadSearchSection>
            <div className="d-flex mb-3">
              <InputSearch
                value={dataFilter?.q}
                onChange={onInputSearchChange}
              />

              <FilterButton
                active={dataFilter?.active}
                onClick={toggleModalFilter}
              />
            </div>
          </CRUDLayout.HeadSearchSection>
          <CRUDLayout.HeadButtonSection>
            <BackButton onClick={() => history.goBack()} />
          </CRUDLayout.HeadButtonSection>
        </CRUDLayout.Head>
        <Alert
          show={alertConfig.show}
          variant={alertConfig.variant}
          text={alertConfig.text}
          showCloseButton={true}
          onClose={() => {
            setAlertConfig({
              ...alertConfig,
              show: false,
            });
          }}
        />
        {isLoading ? (
          <DataStatus loading={true} text="Memuat data..." />
        ) : data?.length ? (
          <Table />
        ) : (
          <DataStatus text="Tidak ada data" />
        )}

        {modalFilter && (
          <ModalFilterPreform
            toggle={toggleModalFilter}
            data={dataFilter}
            setData={setDataFilter}
          />
        )}
      </CRUDLayout>
    );
  },
);
